/*
 * @Description: vr专区
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-10 09:17:33
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 21:20:00
 */
import React ,{ useEffect }from 'react' ;
import { Carousel } from 'antd';
import SelfVr from './selfvr';

let mySwiper = null ;

const VrBlock = (props) => {
  useEffect(() => {
    mySwiper = new window.Swiper('.swiper-container', {
      // autoplay: {
      //   delay : 5000
      // },//可选选项，自动滑动
      autoplay : 5000 ,
      slidesPerView : 4,
      // spaceBetween: 10 ,
      // slidesOffsetBefore:4 ,
      // slidesOffsetAfter :4 ,
      // offsetPxBefore : 4,
      // offsetPxAfter : 4,
      slidesPerGroup : 4,
    })
    // console.log('vrlist',props);
  },[]) ;

  const handPreClick = () => {
    // mySwiper.slidePrev();
     mySwiper.swipePrev();
    // console.log('pre');
  }

  const handleNextClick = () => {
    // mySwiper.slideNext();
    mySwiper.swipeNext();
    // console.log('next');
  }
  return(
    <div className="vr-block">
      <span><a href="//hrgnode.58.com/zcm/companyvrpc/list" target="_blank">more >></a></span>
      <div className="vr-block-title"></div>
      <div className="vr-block-content swiper-container">
        <div className="swiper-wrapper">
          {
            props.data.map((item,index) => {
              return(
                <SelfVr data={item} className="swiper-slide" key={index}/>
              )
            })
          }
        </div>
      </div>
      <div className="button-pre-block" onClick={handPreClick}></div>
      <div className="button-next-block" onClick={handleNextClick}></div>
    </div>
  )
}

export default VrBlock ;